import axios from "axios";

const endpoint = "/api/users";

/**
 * API de usuarios
 * Contiene métodos para gestionar los usuarios.
 *
 * @namespace UsersAPI
 */
export default {
  /**
   * Sends a GET request to the `/api/users` endpoint with the specified query parameters.
   * @param query - An object that contains filters and search criteria for the request.
   * @returns The result of the axios GET request.
   */
  getCustomers(websiteId, query) {
    return axios.get(`${endpoint}/websiteId/${websiteId}`, {
      params: query
    });
  },
  /**
   * Inicia sesión un cliente final enviando sus credenciales al servidor.
   *
   * @function
   * @memberof AuthAPI
   * @param {Object} data - Datos de inicio de sesión del usuario.
   * @param {string} [data.email] - Correo electrónico del usuario.
   * @param {string} [data.password] - Contraseña del usuario.
   * @param {string} [data.googleToken] - Token obtenido a tráves de Google Sign In.
   * @param {string} data.domain - Dominio del sitio a iniciar sesión.
   * @param {string} data.websiteId - Id del website a iniciar sesión.
   * @returns {Promise} Promesa que resuelve con la respuesta del servidor.
   * @throws {Error} Si la solicitud falla.
   */
  loginFinalCustomer(data) {
    return axios.post(`${endpoint}/login`, data);
  },
  /**
   * Registrar un cliente final enviando.
   *
   * @function
   * @memberof AuthAPI
   * @param {Object} data - Datos de inicio de sesión del usuario.
   * @param {string} data.email - Correo electrónico del usuario.
   * @param {string} data.fullName - Nombre completo del usuario.
   * @param {string} data.password - Contraseña del usuario.
   * @param {string} data.domain - Dominio del sitio a iniciar sesión.
   * @param {string} data.websiteId - Id del website a iniciar sesión.
   * @returns {Promise} Promesa que resuelve con la respuesta del servidor.
   * @throws {Error} Si la solicitud falla.
   */
  signupFinalCustomer(data) {
    return axios.post(`${endpoint}`, data);
  }
};
